export class ImageSizeError extends Parse.Error {
  public static readonly MESSAGE = 'Incorrect image size!';
  public static readonly CODE = 1;

  constructor() {
    super(ImageSizeError.CODE, ImageSizeError.MESSAGE);
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/errors/image-size-error.ts